export const list = {
  table: {
    id: 'ID',
    no: 'No',
    name: 'Name',
    volume: 'Volume',
    cost: 'Cost',
    time: 'Time',
    customer: 'Customer',
    washingTime: 'Washing Time',
    timeUnit: 'mins',
    water: 'Water',
  },
  pageHeader: {
    title: 'Washing Method',
    new: 'New',
  },
}
